import { FirstCallFilterModelComparator } from './comparators/first-call-model-comparator';
import {
  ConfigureOptionsParams,
  FilterOptions,
  IFilterComparator,
  FilterPassParams
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { FirstCallFilterModel } from '../../../grid/components/filters/first-call-filter/first-call-filter.component';
import { filterFirstCall } from '../../issue/call-feature';
import { FilterResultFacade } from '../filter-result-facade';
import { FilterHandlerBase } from './base/filter-handler-base';

export class FirstCallFilterHandler extends FilterHandlerBase {
  private comparator: FirstCallFilterModelComparator;

  get isInclusiveExclusive(): boolean {
    return false;
  }

  get name(): string {
    return CalendarGridColumnName.FirstCall;
  }

  configureFilterOptions(params: ConfigureOptionsParams): void {
    //do nothing
  }

  getFilterOptions(filterOptions: FilterOptions): any {
    return filterOptions;
  }

  hasValidDiff(
    options: FilterOptions,
    grid: Partial<FirstCallFilterModel>,
    store: FirstCallFilterModel
  ): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options: FilterOptions
  ): IFilterComparator<FirstCallFilterModel> {
    if (!this.comparator) {
      this.comparator = new FirstCallFilterModelComparator();
    }
    return this.comparator;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const firstCallDate = params.filters[this.name];
    const data = params.deal;
    const isCallFeatureFilterPassed: boolean = filterFirstCall(
      firstCallDate,
      data
    );
    result.applyDealFilerResult(data.id, this.name, isCallFeatureFilterPassed);

    return isCallFeatureFilterPassed;
  }
}
